import { Button } from '@/components/ui'
import type { Edit } from '@/modules/projects/stores/types'
import { cn, fromNow } from '@/utils'

const whoAndWhen = (edit: Edit) =>
  [edit.madeBy, `${fromNow(edit.createdAt)} ago`].filter(Boolean).join(' · ')

// Why an entry offers no undo button: it was taken back already, or it re-read pages.
const noUndoReason = (edit: Edit) => {
  if (edit.undoneAt) return 'Undone'
  if (!edit.undoable) return 'Cannot be undone'
  return null
}

export const HistoryEntry = ({
  edit,
  onUndo,
}: {
  edit: Edit
  onUndo: (edit: Edit) => void
}) => {
  const reason = noUndoReason(edit)
  return (
    <li data-edit-entry={edit.id} className="flex items-start gap-3 py-2.5">
      <div className="min-w-0 flex-1">
        <p
          className={cn(
            'text-sm',
            edit.undoneAt && 'text-ink-subtle line-through',
          )}
        >
          {edit.summary}
        </p>
        <p className="text-xs text-ink-subtle">{whoAndWhen(edit)}</p>
      </div>
      {reason ? (
        <span className="shrink-0 pt-0.5 text-xs text-ink-subtle">
          {reason}
        </span>
      ) : (
        <Button size="xs" theme="outline" onClick={() => onUndo(edit)}>
          Undo
        </Button>
      )}
    </li>
  )
}
